/* ------------------------------------------------------------------
// TODO: esbuild移行時に命名やimportできるようにリファクタリング必要
--------------------------------------------------------------------- */
$(document).on("focus", ".datePicker", (ele) => {
  const dateFormat = ele.currentTarget.dataset.dateFormat || "yy/mm/dd";
  $(".datePicker").datepicker({
    dateFormat,
  });
});
